function createScriptTag(options) {
  const { async, defer, id, src, cb, text, onError } = options;
  const script = document.createElement("script");
  if (async) {
    script.setAttribute("async", "");
  }
  if (defer) {
    script.setAttribute("defer", "");
  }
  if (id) {
    script.id = id;
  }
  if (src) {
    script.src = src;
  }
  if (cb) {
    script.onload = cb;
  }
  if (text) {
    script.text = text;
  }
  if (onError) {
    script.onerror = onError;
  }
  return script;
}
function injectTags(tags) {
  const head = document.head;
  if (head) {
    tags.forEach((tag) => {
      head.appendChild(tag);
    });
  }
}
export {
  createScriptTag,
  injectTags
};
//# sourceMappingURL=inject-scripts.js.map
